import { render } from "./OilMeter.vue?vue&type=template&id=2aa697d8&scoped=true"
import script from "./OilMeter.vue?vue&type=script&lang=js"
export * from "./OilMeter.vue?vue&type=script&lang=js"

import "./OilMeter.vue?vue&type=style&index=0&id=2aa697d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa697d8"]])

export default __exports__